import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=2407bcde&scoped=true&"
import script from "./ConversationList.vue?vue&type=script&lang=ts&"
export * from "./ConversationList.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=2407bcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407bcde",
  null
  
)

export default component.exports